<template>
  <div>
    <CButton
      color="primary"
      class="ml-1"
      @click.prevent="openModal"
      variant="outline"
    >
      {{ $t("family.dashboard.tour.cta") }} 🎯
    </CButton>
    <CModal :show="modal.show" :closeOnBackdrop="false" :centered="true">
      <template #header>&nbsp;</template>

      <figure
        class="
          w-100
          d-flex
          justify-content-center
          align-items-center
          my-3
          position-absolute
        "
        style="top: -150px; left: 50%; transform: translateX(-50%)"
      >
        <img
          src="/loonity/img/new_user.png"
          alt="User Tour Illustration"
          class="img-fluid"
          style="max-height: 200px"
        />
      </figure>

      <h5 class="modal-title text-center w-100" style="margin-top: 75px">
        {{ $t("family.dashboard.tour.description") }}
      </h5>

      <template #footer>
        <div class="w-100 d-flex justify-content-center align-items-center">
          <CButton
            color="primary"
            variant="outline"
            class="mr-1"
            @click.prevent="closeModal"
          >
            {{ $t("common.editor.cancel") }}
          </CButton>
          <CButton color="primary" class="ml-1" @click.prevent="startTour">
            {{ $t("family.dashboard.tour.cta") }}
          </CButton>
        </div>
      </template>
    </CModal>
  </div>
</template>

<script>
import { apiGet } from "../../../helpers/apiHelper";

export default {
  data() {
    return {
      modal: {
        show: false,
      },
    };
  },

  computed: {
    hasCompletedTour() {
      return this.$store.state.hasCompletedTour;
    },
  },

  methods: {
    startTour() {
      this.$tours["newUserTour"].start();
      this.closeModal();
    },

    openModal() {
      this.modal.show = true;
    },

    closeModal() {
      this.modal.show = false;
    },

    async fetchUserData() {
      if (this.$store.state.hasCompletedTour) {
        return;
      }

      const userId = this.$store.state.connections.current.user;
      const response = await apiGet("account_user", [userId]);

      if (response && response.status === 200) {
        this.$store.commit("set", [
          "hasCompletedTour",
          response.data.extra.has_completed_tour,
        ]);

        if (!response.data.extra.has_completed_tour) {
          this.modal.show = true;
        }
      }
    },
  },

  async mounted() {
    await this.fetchUserData();
  },
};
</script>
